(function($, Drupal, once) {
  Drupal.behaviors.inlineStatusMessages = {
    attach(context) {
      $(once('rutherford-status-message', '[data-status-message]', context))
        .each(function eachMessage() {
          if (
            $(this).parents('form,[data-form-wrapper],#block-mainpagecontent')
              .length
          ) {
            $(this)
              .find('.alert.u-breakout')
              .removeClass('u-breakout');
          }
        });
    },
  };

  Drupal.theme.message = function themeMessages(_ref, _ref2) {
    const { text } = _ref;
    const { type } = _ref2;
    const { id } = _ref2;

    const messagesTypes = Drupal.Message.getMessageTypeLabels();
    let messageWrapper = document.createElement('div');

    const drupalTypesToBootstrap = {
      error: 'danger',
      warning: 'warning',
      status: 'success',
    };

    const bootstrapType = drupalTypesToBootstrap[type];

    const messageHTML = `<div class="alert alert-${bootstrapType} alert-dismissible status--${type} u-p-2 u-mb-0 u-breakout u-text-large" x-data="{open:true}" x-show="open">
        <div class="container">
          ${text}
          <button type="button" class="close u-h-full u-text-small u-opacity-100" @click="open = false;">
            <span class="u-visually-hidden">{{ 'Close'|t }}</span>
            <span aria-hidden="true">
              <svg class="icon" focusable="false">
                <use xlink:href="themes/custom/rutherford/dist/img/sprite/sprite.svg#cti--close"></use>
              </svg>
            </span>
          </button>
        </div>
      </div>`;

    messageWrapper.innerHTML = messageHTML;
    messageWrapper = messageWrapper.firstChild;

    messageWrapper.setAttribute(
      'role',
      type === 'error' || type === 'warning' ? 'alert' : 'status',
    );
    messageWrapper.setAttribute('data-drupal-message-id', id);
    messageWrapper.setAttribute('data-drupal-message-type', type);

    messageWrapper.setAttribute('aria-label', messagesTypes[type]);

    return messageWrapper;
  };
})(jQuery, Drupal, once);
